import { render, staticRenderFns } from "./DialogTaoPhieuChuyenTienNganHangNoiBo.vue?vue&type=template&id=243c2a29"
import script from "./DialogTaoPhieuChuyenTienNganHangNoiBo.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuChuyenTienNganHangNoiBo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports